module.exports = __webpack_public_path__ + "static/media/Gratt.bbc2c132.mp3";